(() => {
  'use strict';
  // No welcome codes, account requests or automatic application in the storefront.
  // Remove any previous card markup if cached alongside this updated asset.
  document.querySelectorAll('[data-idp-offer]').forEach(card => card.remove());
  document.querySelector('#IdpCartForm')?.addEventListener('submit', () => {
    const input = document.querySelector('#IdpCartDiscount');
    if (input && !input.value.trim()) input.disabled = true;
  }, true);
})();
